/* eslint-disable jsx-a11y/no-autofocus */
import React, {Fragment, useEffect, useRef, useState} from "react";
import {useDispatch} from "react-redux";
import {toast} from "react-toastify";
import {Card, FormGroup, Input, InputGroup, InputGroupText} from "reactstrap";
import OtpInput from "react-otp-input";
import logo from "../../assets/img/brand/brand-stacked.svg";
import ZeusButton from "../../components/Button";
import {resetPassword, verifyEmail, verifyToken} from "../../redux/Actions/login.actions";
import "./styles.scss";

const ACTIONS = {
  1: "Request OTP",
  2: "Validate OTP",
  3: "Rest Password",
};

const ForgotPassword = ({setShowForgotPassword}) => {
  const dispatch = useDispatch();
  const intervalRef = useRef();
  const [authObject, setAuthObject] = useState({email: ""});
  const [action, setAction] = useState(1);
  const [timer, setTimer] = useState(0);

  const backToLogin = () => {
    setShowForgotPassword(false);
  };

  const handleVerifyEmail = () => {
    setTimer(0);
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
    const callback = () => {
      intervalRef.current = setInterval(() => setTimer((prevTime) => prevTime + 1), 1000);
      setAction(2);
    };
    if (authObject.email) {
      dispatch(verifyEmail({email: authObject.email}, callback));
    } else {
      toast.error("Please enter your email");
    }
  };

  const handleVerifyToken = () => {
    const callback = () => {
      setAction(3);
    };
    if (authObject.token) {
      dispatch(verifyToken({email: authObject.email, token: authObject.token}, callback));
    } else {
      toast.error("Please enter your OTP");
    }
  };

  const handleResetPassword = () => {
    if (authObject.new_password) {
      if (authObject.confirm_password) {
        dispatch(
          resetPassword(
            {
              email: authObject.email,
              new_password: authObject.new_password,
              confirm_password: authObject.confirm_password,
              token: authObject.token,
            },
            backToLogin
          )
        );
      } else {
        toast.error("Please enter confirm password");
      }
    } else {
      toast.error("Please enter new password");
    }
  };

  const handleClick = () => {
    const EVENTS = {
      1: handleVerifyEmail,
      2: handleVerifyToken,
      3: handleResetPassword,
    };

    EVENTS[action]();
  };

  const handleKeyPress = (event) => {
    if (event.keyCode === 13) {
      handleClick();
    }
  };

  useEffect(() => {
    if (authObject?.token?.length === 6 && action === 2) {
      handleClick();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authObject]);

  return (
    <div className="containers">
      <div className="bg_img">
        <Card className="login_container">
          <div className={`login_block ${action === 2 ? "login-block-otp" : ""}`}>
            <h3 style={{fontSize: "22px", marginRight: "auto"}}>Forgot Password</h3>
            <div className="login_area">
              <div className="mb-1">
                {action === 1 && <small>Please Enter your email.</small>}
                {action === 2 && <small>Please enter your OTP.</small>}
                {action === 3 && <small>Please enter new password.</small>}
              </div>

              {action === 1 && (
                <FormGroup className="mb-3 mr-4">
                  <InputGroup className="input-group-alternative">
                    <InputGroupText>
                      <i className="ni ni-email-83" />
                    </InputGroupText>
                    <Input
                      placeholder="Email"
                      type="email"
                      autoComplete="new-email"
                      onKeyDown={handleKeyPress}
                      autoFocus={true}
                      id={"email"}
                      // value={authObject.email}
                      onChange={(e) =>
                        setAuthObject({
                          ...authObject,
                          email: e.target.value,
                        })
                      }
                    />
                  </InputGroup>
                </FormGroup>
              )}

              {action === 2 && (
                <FormGroup className="mb-3 mr-4 otp-container">
                  <OtpInput
                    containerStyle={"otp"}
                    inputStyle={"otpInput"}
                    inputType="tel"
                    numInputs={6}
                    onChange={(value) =>
                      setAuthObject({
                        ...authObject,
                        token: value,
                      })
                    }
                    shouldAutoFocus
                    renderInput={(props) => <input data-cy={"cy-otp"} {...props} />}
                    value={authObject.token}
                  />
                </FormGroup>
              )}
              {action === 3 && (
                <Fragment>
                  <FormGroup className="mb-3 mr-4">
                    <InputGroup className="input-group-alternative">
                      <InputGroupText>
                        <i className="ni ni-lock-circle-open" />
                      </InputGroupText>
                      <Input
                        autoFocus={true}
                        placeholder="New Password"
                        type="password"
                        id={"new-password"}
                        onChange={(e) =>
                          setAuthObject({
                            ...authObject,
                            new_password: e.target.value,
                          })
                        }
                      />
                    </InputGroup>
                  </FormGroup>
                  <FormGroup className="mb-3 mr-4">
                    <InputGroup className="input-group-alternative">
                      <InputGroupText>
                        <i className="ni ni-lock-circle-open" />
                      </InputGroupText>
                      <Input
                        onKeyDown={handleKeyPress}
                        placeholder="Confirm Password"
                        type="password"
                        id={"confirm-password"}
                        onChange={(e) =>
                          setAuthObject({
                            ...authObject,
                            confirm_password: e.target.value,
                          })
                        }
                      />
                    </InputGroup>
                  </FormGroup>
                </Fragment>
              )}
              <div className="d-flex">
                <ZeusButton data-cy="submit-btn" onClick={handleClick}>
                  {ACTIONS[action]}
                </ZeusButton>
                {action === 2 ? (
                  <ZeusButton
                    type="info-small"
                    onClick={handleVerifyEmail}
                    disabled={timer <= 20}
                    data-cy="resend-btn"
                  >
                    {`Resend OTP ${timer <= 20 ? 20 - timer : ""}`}
                  </ZeusButton>
                ) : (
                  <ZeusButton type="info-small" onClick={backToLogin}>
                    Back To Login
                  </ZeusButton>
                )}
              </div>
            </div>
          </div>
          {/* LOGO BLOCK */}
          <div className="logo_block">
            <img
              className="form-img"
              src={logo}
              alt="ERP logo"
              style={{height: "100%", width: "100%"}}
            />
          </div>
        </Card>
      </div>
    </div>
  );
};

export default ForgotPassword;
